import React, { useState } from 'react';
import { ImageResult } from '../types';
import { ExternalLink } from 'lucide-react';

interface PoseImageProps {
    poseName: string;
    imageResult?: ImageResult;
    className?: string;
}

export const PoseImage: React.FC<PoseImageProps> = ({ poseName, imageResult, className = "w-full h-full object-cover" }) => {
    const [hasError, setHasError] = useState(false);

    // If no URL or confidence is below 55 (handled by service returning null url but check just in case), or image failed to load
    const shouldShowPlaceholder = !imageResult?.url || hasError;

    if (shouldShowPlaceholder) {
        return (
            <div className={`flex flex-col items-center justify-center bg-orange-50 text-orange-800 p-4 text-center ${className.replace('object-cover', '')}`}>
                <div className="text-4xl mb-2">🧘</div>
                <h4 className="font-bold text-sm mb-1">{poseName}</h4>
                <p className="text-xs text-orange-600">
                    View pose instructions in the details panel.
                </p>
            </div>
        );
    }

    return (
        <>
            <img
                src={imageResult!.url!}
                alt={poseName}
                className={className}
                onError={() => setHasError(true)}
            />
            {imageResult?.source === 'ai-generated' && (
                <span className="absolute bottom-2 right-2 px-2 py-1 bg-white/60 backdrop-blur-sm rounded text-[9px] text-gray-500 font-medium">AI generated image</span>
            )}
        </>
    );
};
